export default "__VITE_ASSET__OZGT4W5R__"